import { render, staticRenderFns } from "./DialogCreateChildDepartment.vue?vue&type=template&id=5f7c12a0&scoped=true&"
import script from "./DialogCreateChildDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogCreateChildDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateChildDepartment.vue?vue&type=style&index=0&id=5f7c12a0&lang=scss&scoped=true&"
import style1 from "./DialogCreateChildDepartment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c12a0",
  null
  
)

export default component.exports